const state = {
  unreadMessages: null,
  showOnInit: false,
  isOpen: false,
};

const getters = {
};

const actions = {
};

const mutations = {
  setUnreadMessages(state, unreadMessages) {
    state.unreadMessages = unreadMessages;
  },
  setShowOnInit(state, showOnInit) {
    state.showOnInit = showOnInit;
  },
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
